import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDebtRegister = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M46.3469 43.5566L53.8911 51.1008",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.7998 40.884C44.7998 43.8195 42.4201 46.1992 39.4846 46.1992L16.5151 46.1992C13.5795 46.1992 11.1998 43.8195 11.1998 40.884L11.1998 5.31448C11.1998 2.37895 13.5795 -0.000777335 16.5151 -0.000777079L39.4846 -0.000775071C42.4201 -0.000774814 44.7998 2.37894 44.7998 5.31448L44.7998 40.884Z",
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2851 54.2586L7.63073 54.2586C5.15602 54.2586 3.14987 52.2524 3.14987 49.7777L3.14988 12.4444C3.14988 9.9697 5.15603 7.96354 7.63074 7.96354L35.2851 7.96355C37.7598 7.96355 39.7659 9.9697 39.7659 12.4444L39.7659 49.7777C39.7659 52.2524 37.7598 54.2586 35.2851 54.2586Z",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38.0504,
			cy: 35.9523,
			r: 11.3944,
			fill: "white",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 31L35 41",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35,
			cy: 33,
			r: 1.25,
			stroke: "#031839",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 41,
			cy: 39,
			r: 1.25,
			stroke: "#031839",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.65 18.11C20.8367 18.11 20.9833 18.1633 21.09 18.27C21.2033 18.37 21.26 18.51 21.26 18.69V20.64C21.26 20.9067 21.2367 21.1133 21.19 21.26C21.15 21.4067 21.0767 21.5233 20.97 21.61C20.8633 21.6967 20.7033 21.77 20.49 21.83C20.23 21.91 19.93 21.9733 19.59 22.02C19.2567 22.0667 18.94 22.09 18.64 22.09C17.8933 22.09 17.2467 21.9467 16.7 21.66C16.1533 21.3667 15.7333 20.95 15.44 20.41C15.1467 19.8633 15 19.2167 15 18.47C15 17.7367 15.1433 17.1 15.43 16.56C15.7233 16.0133 16.14 15.5933 16.68 15.3C17.22 15.0067 17.85 14.86 18.57 14.86C19.4967 14.86 20.2633 15.1 20.87 15.58C20.97 15.66 21.04 15.74 21.08 15.82C21.12 15.9 21.14 16 21.14 16.12C21.14 16.2933 21.09 16.4433 20.99 16.57C20.8967 16.69 20.7833 16.75 20.65 16.75C20.5633 16.75 20.4833 16.7367 20.41 16.71C20.3433 16.6833 20.26 16.64 20.16 16.58C19.88 16.4067 19.6233 16.2833 19.39 16.21C19.1567 16.1367 18.9 16.1 18.62 16.1C17.26 16.1 16.58 16.89 16.58 18.47C16.58 19.2833 16.7567 19.89 17.11 20.29C17.4633 20.69 17.9967 20.89 18.71 20.89C19.0967 20.89 19.48 20.84 19.86 20.74V19.19H18.94C18.7467 19.19 18.5967 19.1433 18.49 19.05C18.3833 18.9567 18.33 18.8233 18.33 18.65C18.33 18.4767 18.3833 18.3433 18.49 18.25C18.5967 18.1567 18.7467 18.11 18.94 18.11H20.65Z",
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 36H23",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 32H23",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 28H23",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 40H18.5H21",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		})
	]
});
export default SvgDebtRegister;
